<template>
  <!--  <div id="app_box" class="scale-wrapper">-->
  <!--  <el-button @click="changeTheme">切换主题颜色</el-button>-->
  <!--  v-if="!isMobileFlag"-->
  <router-view v-slot="{ Component }">
    <!--
      外壳（layout）是这层 router-view 唯一的组件，直接单实例渲染即可：
      在 / 下的所有路由间切换时，Component 始终是同一个 layout，Vue 会原地复用，
      layout 全程只有一个实例、永不重挂，既不会出现「同一视图渲染两份 → 弹窗出现两次」，
      也不会因切换白名单/非白名单页而重挂外壳、重复请求 Header 等初始化接口。
      叶子页仍通过内层 router-view 正常挂载/卸载。
    -->
    <component :is="Component"/>
  </router-view>
  <div v-if="globalLoading" class="app-global-loading">
    <div class="app-global-loading__dots">
      <span class="app-global-loading__dot"></span>
      <span class="app-global-loading__dot"></span>
      <span class="app-global-loading__dot"></span>
    </div>
  </div>
  <!--  <Device v-else @change="changeStatus"></Device>-->
  <!--  </div>-->
</template>
<script setup>
import {onMounted, onBeforeMount, computed, watch, ref, onBeforeUnmount} from "vue";
import {useStore} from "vuex";
import {loadLanguageAsync} from "@/lang";
import {useRoute, useRouter} from "vue-router";
import {useWebSocket} from "@/Hooks";
import {isMobile} from "@/utils/device";
import Device from "@/views/Device/index.vue"
import {chat} from "./store/modules/chat";
import TencentCloudChat from "@tencentcloud/chat";
import {getImLoginId} from "@/config/im";
import {showNotify} from "@/utils/notifies";
import {readLocalStorageJSON} from "@/utils/json";

const store = useStore();
const router = useRouter();
const route = useRoute();

const globalLoading = computed(() => store.state.system.globalLoading)

const isMobileFlag = ref(false);
const userInfo = computed(() => store.state.user.userInfo);
const langLocal = computed(() => store.state.system.langLocal)

const chatInitInFlight = ref(false)
const chatInitedUserId = ref(null)
// teamId 初始化为 0 问题
const teamId = computed(() => store.state.email.teamID);
const isEnterpriseMainUser = computed(() => store.getters['user/isEnterpriseMainUser']);
// 用户接受继续访问
const changeStatus = () => {
  isMobileFlag.value = false
}

watch(() => langLocal.value, (lang) => {
  loadLanguageAsync(lang)
  // routerToI18n() //多语言绑定
}, {immediate: true})

// 发送消息
const getLocalUserId = () => {
  try {
    return readLocalStorageJSON('userInfo', {})?.id || ''
  } catch (e) {
    return ''
  }
}

const currentUserId = computed(() => {
  const idFromStore = userInfo.value?.id
  return String(idFromStore || getLocalUserId() || '')
})

let userInfoFetchPromise = null

let teamInitPromise = null

const ensureUserInfoReady = async () => {
  const token = String(localStorage.getItem('token') || '')
  if (!token) return
  
  // 检查 store 中的 userInfo 是否有效
  const uid = Number(userInfo.value?.id || 0)
  
  // 如果 store 中没有有效的 userId，尝试从 localStorage 恢复
  if (uid <= 0) {
    try {
      const parsed = readLocalStorageJSON('userInfo', null)
      if (parsed?.id && parsed.id > 0) {
        // 先恢复缓存的用户信息到 store，避免后续调用时 userId 为空
        await store.dispatch('user/UserLogin', parsed)
      }
    } catch (e) {
      console.error('Failed to restore userInfo from localStorage', e)
    }
  }
  
  // 然后从服务器获取最新的用户信息
  if (!userInfoFetchPromise) {
    userInfoFetchPromise = Promise.resolve()
      .then(() => store.dispatch('user/getUserInfoForGUID'))
      .catch((e) => {
        console.error('Failed to fetch user info', e)
      })
      .finally(() => {
        userInfoFetchPromise = null
      })
  }
  await userInfoFetchPromise
}

const ensureTeamReady = async () => {
  const token = String(localStorage.getItem('token') || '')
  if (!token) return
  if (!teamInitPromise) {
    teamInitPromise = Promise.resolve()
      .then(() => store.dispatch('email/ensureTeamListReady'))
      .catch((e) => {
        console.error('Failed to init team list', e)
      })
      .finally(() => {
        teamInitPromise = null
      })
  }
  await teamInitPromise
}

onBeforeMount(async () => {
  try {
    await ensureUserInfoReady()
  } catch (e) {
  }
  try {
    await ensureTeamReady()
  } catch (e) {
  }
})

let wsStop = null
let wsActiveUserId = ''
let wsLocalPollTimer = null

const restartWS = async (nextUserId) => {
  const uid = String(nextUserId || '')

  try {
    if (typeof wsStop === 'function') {
      await wsStop()
    }
  } catch (e) {
  }

  wsStop = null
  wsActiveUserId = ''

  if (!uid) return

  const { startWS, stopWS } = useWebSocket(uid, store)
  wsStop = stopWS
  wsActiveUserId = uid
  await startWS()
}

onMounted(async () => {
  let pendingAccountSwitchLoading = false
  let pendingAccountSwitchLoadingStartAt = 0
  try {
    pendingAccountSwitchLoading = sessionStorage.getItem('__pending_account_switch_loading__') === '1'
  } catch (e) {
    pendingAccountSwitchLoading = false
  }
  if (pendingAccountSwitchLoading) {
    pendingAccountSwitchLoadingStartAt = Date.now()
    try {
      store.commit('system/setGlobalLoading', true)
    } catch (e) {
    }
    try {
      await new Promise((resolve) => requestAnimationFrame(() => resolve()))
      const el = document.getElementById('__preload_global_loading__')
      if (el) {
        el.style.display = 'none'
      }
    } catch (e) {
    }
  }
  isMobileFlag.value = isMobile();
  // 获取默认主题
  // let html = document.querySelector('html')
  // html.setAttribute('data-theme', localStorage.getItem("theme"));
  // 弹窗测试
  // let target = {
  //   "msg_front_from": "<CMCCAccountaasdfasdasdfasfdo@139.com>",
  //   "msgTxt": "回复：RE：hello world@阿里山来的拉迪说ASDf阿斯顿发堷企鹅们阿里山地方asdfasdfasdasd",
  //   "msg_front_subject":"回复：RE：hello world@阿里山来的拉迪说ASDf阿斯顿发堷企鹅们阿里山地方asdfasdfasdasd",
  //   "msg_front_type": "msg_front_email",
  //   "userId": "1764907866498379777"
  // }
  
  // target.msgTxt = truncateByBytes(target.msgTxt,60)
  // console.log(target,'tar')
  // showNotify(1, target)

  // startLoading()
  try {
    await ensureUserInfoReady()
    await ensureTeamReady()
    if (userInfo.value.companyId) {
      localStorage.setItem('companyId', userInfo.value.companyId);
    }
    if (teamId.value) {
      await store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value, isUpdate: true})
    }
    // IM 身份使用的 userID 由 src/config/im.js 配置（默认 guid/UID）
    const imLoginId = getImLoginId(userInfo.value)
    if (imLoginId && !chatInitInFlight.value && chatInitedUserId.value !== imLoginId) {
      chatInitInFlight.value = true
      try {
        const ok = await store.dispatch('chat/initChat', imLoginId);
        // 仅在登录成功时标记已初始化，失败时保留机会在下次路由变化/刷新时重试
        if (ok) {
          chatInitedUserId.value = imLoginId
        }
      } catch (e) {
        console.error('Failed to init chat', e)
      } finally {
        chatInitInFlight.value = false
      }
    }
    // userTime()
    handleRouteChange(route.path);
  } finally {
    if (pendingAccountSwitchLoading) {
      const minMs = 1500
      const elapsed = Date.now() - (pendingAccountSwitchLoadingStartAt || 0)
      const remain = minMs - elapsed
      if (remain > 0) {
        try {
          await new Promise((resolve) => window.setTimeout(resolve, remain))
        } catch (e) {
        }
      }
      try {
        sessionStorage.removeItem('__pending_account_switch_loading__')
      } catch (e) {
      }
      try {
        const el = document.getElementById('__preload_global_loading__')
        if (el) {
          el.style.display = 'none'
        }
      } catch (e) {
      }
      try {
        store.commit('system/setGlobalLoading', false)
      } catch (e) {
      }
    }
  }
})

// onMounted(() => {
  // isMobileFlag.value = isMobile();
  // 初始化执行一次
// });

watch(
    () => route.path,
    (newPath) => {
      handleRouteChange(newPath);
    }
);

function handleRouteChange(path) {
  console.log(path, '当前路径');
  if (path.startsWith("/cloud/download") || path.startsWith("/cloud/info")) {
    console.log("文件分享路径");
    return;
  }

  isMobileFlag.value = isMobile();

  ensureUserInfoReady()
    .then(() => ensureTeamReady())
    .then(() => {
      if (userInfo.value.companyId) {
        localStorage.setItem("companyId", userInfo.value.companyId);
      }

      if (teamId.value) {
        store.dispatch("user/checkUserInfoIsAdmin", {
          teamId: teamId.value,
        });
      }

      // IM 身份使用的 userID 由 src/config/im.js 配置（默认 guid/UID）
      const imLoginId = getImLoginId(userInfo.value)
      if (imLoginId && !chatInitInFlight.value && chatInitedUserId.value !== imLoginId) {
        chatInitInFlight.value = true
        Promise.resolve(store.dispatch("chat/initChat", imLoginId))
          .then((ok) => {
            // 仅在登录成功时标记已初始化
            if (ok) {
              chatInitedUserId.value = imLoginId
            }
          })
          .catch((e) => {
            console.error('Failed to init chat', e)
          })
          .finally(() => {
            chatInitInFlight.value = false
          })
      }
    })
}

const currConversation = computed(() => store.state.chat.currConversation)
const sdkStatus = computed(() => store.state.chat.sdkStatus)

// 监听 IM 登出状态，重置初始化标记以允许重新登录（解决同账号重新登录不重试的问题）
watch(sdkStatus, (newStatus, oldStatus) => {
  if (newStatus === 'idle' && oldStatus && oldStatus !== 'idle') {
    chatInitedUserId.value = null
  }
})

// 监听处理（内部判断 SDK 状态，避免未登录时报错）
chat.on(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, (conversationList) => {
  if (sdkStatus.value !== 'ready') return;
  store.dispatch('chat/updateConversationList');

  const currentConv = currConversation.value?.conversation;
  if (!currentConv) return;
  for (const conversation of conversationList.data) {
    if (conversation.conversationID === currentConv.conversationID) {
      store.dispatch('chat/updateCurrentConversation', {conversation});
      break;
    }
  }
});
chat.on(TencentCloudChat.EVENT.GROUP_LIST_UPDATED, () => {
  if (sdkStatus.value !== 'ready') return;
  store.dispatch('chat/updateGroupList');
});

// 收到消息后更新右下角弹窗信息
chat.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, async (e) => {
  if (sdkStatus.value !== 'ready') return;
  if (!e.data || !e.data[0]) return;
  const conversationID = e.data[0].conversationID;
  try {
    const result = await chat.getConversationProfile(conversationID);
    store.dispatch('chat/updateCurrentConversation', {conversation: result.data.conversation});
  } catch (err) {
    console.warn('getConversationProfile error:', err);
  }
});

// onBeforeUnmount(() => {
//   timerUser.value = null;
// })

// 主题切换
// const changeTheme = () => {
//   console.log('切换主题颜色')
//   let html = document.querySelector('html')
//   let currentTheme = html.getAttribute('data-theme');
//   console.log(currentTheme, 'currentTheme')
//   if (currentTheme === "light" || currentTheme === null) {
//     html.setAttribute('data-theme', 'dark');
//     localStorage.setItem("theme", "dark")
//   } else {
//     html.setAttribute('data-theme', 'light');
//     localStorage.setItem("theme", "light")
//   }
// }

let timers = null;
const emailMessages = ref([])
const emailData = computed(() => store.state.message.emailData)
onMounted(async () => {
  await restartWS(currentUserId.value)
  console.log(router.options.routes, 'router')

  // localStorage is not reactive in the same tab. If login only writes localStorage,
  // poll for userId change to ensure WS becomes active without a hard refresh.
  try {
    if (!wsLocalPollTimer) {
      wsLocalPollTimer = window.setInterval(async () => {
        const localId = String(getLocalUserId() || '')
        if (localId && localId !== String(wsActiveUserId || '')) {
          await restartWS(localId)
        }
      }, 1000)
    }
  } catch (e) {
  }
})

watch(
  () => currentUserId.value,
  async (next) => {
    const uid = String(next || '')
    if (uid === String(wsActiveUserId || '')) return
    await restartWS(uid)
  }
)

onBeforeUnmount(() => {
  try {
    if (wsLocalPollTimer) {
      clearInterval(wsLocalPollTimer)
      wsLocalPollTimer = null
    }
  } catch (e) {
  }
  try {
    if (typeof wsStop === 'function') {
      wsStop()
    }
  } catch (e) {
  }
})

// 权限 轮训 实时反馈
// const timerUser = ref(null)
// const userTime = () => {
//   timerUser.value = setInterval(async () => {
//     console.log('timer')
//     await store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value, isUpdate: true})
//   }, 5000)
// }


// 监听storage事件，及时同步用户信息
window.addEventListener('storage', (e) => {
  if (e.key === "token" && (e.newValue === null || e.newValue !== e.oldValue)) {
    location.reload();
  }
});

// main.js 或 App.vue setup
//
// window.addEventListener('storage', (e) => {
//   if (e.key === 'tabIndex') {
//     const newIndex = e.newValue === null ? null : Number(e.newValue)
//     // 更新你的全局状态或局部 ref
//     // store.commit("system/setTabIndex", newIndex);
//     localStorage.setItem("tabIndex", newIndex)
//     location.reload();
//   }
// })


// function updateScale() {
//   const screenWidth = window.innerWidth;
//   const screenHeight = window.innerHeight;
//
//   // 获取当前容器的原始尺寸（假设是 1920x1080 可替换成其他值）
//   const baseWidth = 1920;
//   const baseHeight = 1080;
//
//   const scaleX = screenWidth / baseWidth;
//   const scaleY = screenHeight / baseHeight;
//
//   const app = document.getElementById('app');
//   if (app) {
//     app.style.transformOrigin = 'top left';
//     app.style.transform = `scale(${scaleX})`;
//   }
// }
//
// onMounted(() => {
//   updateScale();
//   window.addEventListener('resize', updateScale);
// });
//
// onBeforeUnmount(() => {
//   window.removeEventListener('resize', updateScale);
// });

</script>
<style lang="less" scoped>
body {
  width: 100% !important;
}

:deep(.el-table) {
  font-weight: normal !important;
}

:deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner) {
  background-color: var(--el-checkbox-checked-bg-color) !important;
  border-color: var(--el-checkbox-checked-input-border-color) !important;
}

:deep(.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner:after) {
  border-color: var(--el-checkbox-checked-icon-color) !important;
}

.scale-wrapper {
  width: 1920px;
  height: 1080px;
  transform-origin: top left;
  position: absolute;
  left: 0;
  top: 0;
}

:deep(.el-input-group__append) {
  box-shadow: none !important;
}
</style>

<style>
.app-global-loading {
  position: fixed;
  inset: 0;
  background: #ffffff;
  z-index: 99999;
}

.app-global-loading__dots {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 10px;
}

.app-global-loading__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2f6cff;
  animation: appGlobalLoadingBreath 1.2s ease-in-out infinite;
}

.app-global-loading__dot:nth-child(2) {
  animation-delay: 0.15s;
}

.app-global-loading__dot:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes appGlobalLoadingBreath {
  0%,
  100% {
    transform: scale(0.8);
    opacity: 0.55;
  }
  50% {
    transform: scale(1.55);
    opacity: 1;
  }
}
</style>
